import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { TOOLBAR_HEIGHT } from 'components/Layout';
import { Space } from 'v2/components/Shared/Space';
import TableOptions from 'v2/components/Shared/TableOptions';
import ordersService from 'v2/services/orders';

const LabelGenerator = () => {
  const [isLoading] = useObservable(() => ordersService.isLoading(), []);
  const [orders] = useObservable(() => ordersService.getOrders(), []);

  const onUnCheckAll = useCallback(() => ordersService.unCheckAllOrders(), []);

  const onGenerateLabels = useCallback(() => ordersService.generateLabel(), []);

  const ordersChecked = (orders || []).filter(o => o.checked);

  const qtOrderChecked = ordersChecked.length;

  if (isLoading || qtOrderChecked < 1) {
    return null;
  }

  const options = [
    {
      label: 'Cancelar',
      callback: onUnCheckAll
    },
    {
      icon: 'local_play',
      label: 'Gerar etiquetas',
      color: 'link' as const,
      callback: onGenerateLabels
    }
  ];

  const inlineStyles = {
    top: 0,
    padding: 16,
    borderRadius: 0
  };

  return (
    <div
      className='sticky z-[15] mb-15 w-full bg-white p-4 text-center shadow-[0_1px_0_0_rgba(0,0,0,0.07)] sm:bottom-0 sm:mb-4'
      id='label-generator'
      style={{ top: TOOLBAR_HEIGHT }}
    >
      <TableOptions items={qtOrderChecked} style={inlineStyles} options={options} />
      <Space axis='vertical' size={16} />
    </div>
  );
};

export default LabelGenerator;
